const React = require('react');

/**
 * List of all supported locales.
 *
 * [LANGUAGE] https://en.wikipedia.org/wiki/ISO_639-1
 * [LANGUAGE] https://en.wikipedia.org/wiki/ISO_639-2
 * [COUNTRY] https://en.wikipedia.org/wiki/ISO_3166-1
 */
const locales = [
  {
    id: 'en',
    label: 'Canada'
  }
];

// TODO - Not launching with en-us but it may have to be added later
// const locales = [
//   {
//     id: 'en-us',
//     label: 'United States'
//   }
// ];

/**
 * Define a default locale (en)
 */
const defaultLocale = 'en';

/**
 * Get a locale by providing it's ID (en).
 *
 * @param {string} id Locale id.
 */
const getLocale = (id) => locales.find((locale) => locale.id === id);

/**
 * Get all supported locales.
 */
const getLocales = () => locales;

/**
 * Get the default locale.
 */
const getDefaultLocale = () => locales.find((locale) => locale.id === defaultLocale);

/**
 * Get a list of all locale id's.
 */
const getLocaleIds = () => locales.map((locale) => locale.id);

/**
 * Validate a locale ID to make sure it is one of the supported locales.
 *
 * @param {string} id Locale ID to validate (en)
 */
const isValidLocale = (id) => locales.find((locale) => locale.id === id) !== undefined;

/**
 * Create a context to hold the current locale.
 */
const LocaleContext = React.createContext(getDefaultLocale());
const LocaleProvider = LocaleContext.Provider;
const LocaleConsumer = LocaleContext.Consumer;

/**
 * A regular expression that strips the locale from beginning of a route.
 *
 * [/en-us]/path
 */
const regexGetLocale = new RegExp(`^/(${getLocaleIds().join('|')})`);

const getActiveLocalFromContext = (ctx) => {
  const { asPath, err, req, query } = ctx;

  // No matter what we are going to at least return the default locale
  let locale = getDefaultLocale();

  // First we check to see if the server has included the locale on the request
  if (req && req.locale && isValidLocale(req.locale)) {
    locale = getLocale(req.locale);
  }
  // If it did not come through from the server we check the client side route for the locale param
  else if (query && query.locale && isValidLocale(query.locale)) {
    locale = getLocale(query.locale);
  }
  // The _error page needs to be handled in a special way.
  // We have not defined a route for error pages so the locale does not get parsed automatically.
  else if (err !== undefined) {
    // This regex will try to find a locale at the beginning of a url
    const matchResults = asPath.match(regexGetLocale);
    const localeMatch = matchResults?.[1];

    // If a locale was found and is valid it gets used
    if (localeMatch && isValidLocale(localeMatch)) {
      locale = getLocale(localeMatch);
    }
  }

  return locale;
};

/**
 * Using CommonJS because this is consumed both client and server side.
 */
module.exports = {
  defaultLocale,
  getDefaultLocale,
  getLocale,
  getLocales,
  getLocaleIds,
  isValidLocale,
  LocaleProvider,
  LocaleConsumer,
  regexGetLocale,
  getActiveLocalFromContext
};
